import { render, staticRenderFns } from "./userNotificationDetails.vue?vue&type=template&id=7d70ce26&scoped=true&"
import script from "./userNotificationDetails.vue?vue&type=script&lang=js&"
export * from "./userNotificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d70ce26",
  null
  
)

component.options.__file = "userNotificationDetails.vue"
export default component.exports